<div class="progress-bar-container" *ngIf="isLoading">
  <div class="progress-bar">
    <div class="progress-bar-fill"></div>
  </div>
</div> 